import { computed } from 'vue';
import { useStoreSsGames } from '~/stores/softswiss/games';
import { useStoreSsPlayer } from '~/stores/softswiss/player';
import { useStoreCurrencyMenu } from '~/stores/strapi/currencyMenu';
import type { IGamesRequestOptions } from '~/types/softswiss/ssGames';

export const useLoadSliderGames = () => {
  const storeSsPlayer = useStoreSsPlayer();
  const storeSsGames = useStoreSsGames();
  const storeCurrencyMenu = useStoreCurrencyMenu();

  const gamesCount = computed(() => (usePlatform().isDesktop ? 21 : 10));

  const loadCollectionGames = async (collectionId: string) => {
    const params: IGamesRequestOptions = {
      collection: collectionId,
      limit: gamesCount.value,
    };

    if (
      storeSsPlayer.isPlayerAuthorised &&
      storeSsPlayer.playerInfo.currency &&
      storeCurrencyMenu.isFiatCurrency(storeSsPlayer.playerInfo.currency)
    ) {
      params.currency = storeSsPlayer.playerInfo.currency;
    }

    const games = await storeSsGames.loadGames(params);

    return games?.data;
  };

  return {
    gamesCount,
    loadCollectionGames,
  };
};
